<template>
  <div class="content">
    <header_index></header_index>
    <div class="bannerWrap">
      <div class="topbanner EC_width display_between">
        <div class="bannerleft">
          <swiper :options="swiperOption"
                  ref="mySwiper">
            <swiper-slide v-for="(item, index) in topRotation"
                          :key="index">
              <img :src="item.resUrl"
                   style="border-radius: 20px 0px 0px 0px; cursor: pointer;"
                   width="930"
                   height="380" />
            </swiper-slide>
            <div class="swiper-pagination"
                 slot="pagination"></div>
          </swiper>
        </div>
        <div class="bannerright">
          <img src="/image/index/index4tuceng.png"
               class="shan" />
          <img v-for="(item, index) in righttopRotation.slice(0, 1)"
               :key="index + '1'"
               :src="item.resUrl"
               width="220"
               height="280"
               style="position: relative;" />
          <div class="brTop">
            <span style="font-size: 18px;font-weight: bold;">欢迎入驻全科知家-专家库</span>
            <span style="line-height:40px">———</span>
            <!-- <span style="font-size: 14px;font-weight: 400;line-height: 25px;" >学科建设频道，旨在为广大会员提供全科医学方向、人才示培养、师资队伍、社会服务和文化发展等领域的最新内容与经验。</span> -->
            <span style="font-size: 12px;font-weight: 400;line-height: 25px;"
                  class="topneirong">全科知家是基层医疗、全科医学行业从业者的在线资料分享平台；
              在这里，聚集了行业、学者、综合医院、社区等多个领域的医学专家；
              拥有全科诊疗、卫生管理、中医技术、全科科研等多维度及多形式的实用课程资源与学习资料；
              在这里，您可以自行建立“个人专家店铺”，上传建立自己的资料库；
              还能将部分资料分享给大家，分享时可自主定价，也可与平台共建“课程”；
              通过会员互相传播，让您在帮助他人的同时获取丰厚的回报！
              全科知家-欢迎您的加入！</span>
          </div>
          <div class="brBottom"
               @click="toEnter">
            <img src="../../assets/img/icon/jia4.png"
                 style="margin-right:10px"
                 alt="" />
            <span>欢迎申请入驻</span>
          </div>
        </div>
      </div>
    </div>
    <div class="top1">
      <span>学院名人堂</span>
    </div>
    <div class="topBox"
         v-if="topList.length > 4">
      <div class="tb3 tbbox"
           @click="toDetail(topList[3].id)">
        <div class="tb3top">
          <img :src="topList[3].headPicture"
               class="touxiang"
               v-show="!isloading"
               alt="" />
          <img src="../../assets/img/organ/loading.png"
               v-show="isloading"
               class="img2"
               alt="">
        </div>
        <span class="name"
              :style="'font-size:'+getNameSize(topList[3].name,3)+'px'">{{ topList[3].name }}</span>
        <div class="more">
          <img src="../../assets/img/icon/fensi3.png"
               style="width:20px;height:17px"
               alt="" />
          <span>{{ topList[3].fans }}</span>
          <img src="../../assets/img/icon/liulan.png"
               style="margin-left:30px"
               alt="" />
          <span>{{ topList[3].pageview }}</span>
        </div>
      </div>
      <div class="tb2 tbbox"
           @click="toDetail(topList[1].id)">
        <div class="tb2top">
          <img :src="topList[1].headPicture"
               class="touxiang"
               v-show="!isloading"
               alt="" />
          <img src="../../assets/img/organ/loading.png"
               v-show="isloading"
               class="img2"
               alt="">
        </div>
        <span class="name"
              :style="'font-size:'+getNameSize(topList[1].name,2)+'px'">{{ topList[1].name }}</span>
        <div class="more">
          <img src="../../assets/img/icon/fensi3.png"
               style="width:20px;height:17px"
               alt="" />
          <span>{{ topList[1].fans }}</span>
          <img src="../../assets/img/icon/liulan.png"
               style="margin-left:30px"
               alt="" />
          <span>{{ topList[1].pageview }}</span>
        </div>
      </div>
      <div class="tb1 tbbox"
           @click="toDetail(topList[0].id)">
        <div class="tb1top">
          <img :src="topList[0].headPicture"
               class="touxiang"
               v-show="!isloading"
               alt="" />
          <img src="../../assets/img/organ/loading.png"
               v-show="isloading"
               class="img2"
               alt="">
        </div>
        <span class="name"
              :style="'font-size:'+getNameSize(topList[0].name,1)+'px'">{{ topList[0].name }}</span>
        <div class="more">
          <img src="../../assets/img/icon/fensi3.png"
               style="width:20px;height:17px"
               alt="" />
          <span>{{ topList[0].fans }}</span>
          <img src="../../assets/img/icon/liulan.png"
               style="margin-left:30px"
               alt="" />
          <span>{{ topList[0].pageview }}</span>
        </div>
        <!-- <img src="../../assets/img/icon/huangguan.png"
             class="huangguan"
             v-show="tbIndex == 1"
             alt="" /> -->
      </div>
      <div class="tb2 tbbox"
           @click="toDetail(topList[2].id)">
        <div class="tb2top">
          <img :src="topList[2].headPicture"
               class="touxiang"
               v-show="!isloading"
               alt="" />
          <img src="../../assets/img/organ/loading.png"
               v-show="isloading"
               class="img2"
               alt="">
        </div>
        <span class="name"
              :style="'font-size:'+getNameSize(topList[2].name,2)+'px'">{{ topList[2].name }}</span>
        <div class="more">
          <img src="../../assets/img/icon/fensi3.png"
               style="width:20px;height:17px"
               alt="" />
          <span>{{ topList[2].fans }}</span>
          <img src="../../assets/img/icon/liulan.png"
               style="margin-left:30px"
               alt="" />
          <span>{{ topList[2].pageview }}</span>
        </div>
      </div>
      <div class="tb3 tbbox"
           @click="toDetail(topList[4].id)">
        <div class="tb3top">
          <img :src="topList[4].headPicture"
               class="touxiang"
               v-show="!isloading"
               alt="" />
          <img src="../../assets/img/organ/loading.png"
               v-show="isloading"
               class="img2"
               alt="">
        </div>
        <span class="name"
              :style="'font-size:'+getNameSize(topList[4].name,3)+'px'">{{ topList[4].name }}</span>
        <div class="more">
          <img src="../../assets/img/icon/fensi3.png"
               style="width:20px;height:17px"
               alt="" />
          <span>{{ topList[4].fans }}</span>
          <img src="../../assets/img/icon/liulan.png"
               style="margin-left:30px"
               alt="" />
          <span>{{ topList[4].pageview }}</span>
        </div>
      </div>
      <div class="tbleft tbbtn">
        <img src="../../assets/img/icon/left.png"
             v-show="tbIndex == 1"
             alt="" />
        <img src="../../assets/img/icon/bg-left.png"
             style="cursor: pointer;"
             @click="tonext(1)"
             v-show="tbIndex == 2"
             alt="" />
      </div>
      <div class="tbright tbbtn">
        <img src="../../assets/img/icon/right.png"
             v-show="tbIndex == 2"
             alt="" />
        <img src="../../assets/img/icon/bg-right.png"
             style="cursor: pointer;"
             v-show="tbIndex == 1"
             @click="tonext(2)"
             alt="" />
      </div>
    </div>
    <div class="top2">
      <div class="top1"
           style="margin-bottom:16px">
        <span>发现专家</span>
      </div>
      <div class="top2xian"></div>
      <div class="t2right">
        <div class="t2rInput">
          <div class="letter"
               @click="isLetter = !isLetter">
            <span>{{ letter ? letter.toUpperCase() : '全部' }}</span>
            <img src="../../assets/img/icon/xia.png"
                 alt="" />
          </div>
          <div style="width: 1px;height: 22px;background: #eee;"></div>
          <input type="text"
                 v-model="name"
                 placeholder="输入专家姓名" />
        </div>
        <div class="t2rBtn"
             @click="toSearch">
          <img src="../../assets/img/icon/search.png"
               alt="" />
        </div>
        <div class="t2rzm"
             v-show="isLetter">
          <table>
            <tr>
              <td :class="letter == '' ? 'letterActiva' : ''"
                  @click="letter = ''">全部</td>
              <td :class="letter == 'a' ? 'letterActiva' : ''"
                  @click="letter = 'a'">A</td>
              <td :class="letter == 'b' ? 'letterActiva' : ''"
                  @click="letter = 'b'">B</td>
              <td :class="letter == 'c' ? 'letterActiva' : ''"
                  @click="letter = 'c'">C</td>
              <td :class="letter == 'd' ? 'letterActiva' : ''"
                  @click="letter = 'd'">D</td>
              <td :class="letter == 'e' ? 'letterActiva' : ''"
                  @click="letter = 'e'">E</td>
              <td :class="letter == 'f' ? 'letterActiva' : ''"
                  @click="letter = 'f'">F</td>
              <td :class="letter == 'g' ? 'letterActiva' : ''"
                  @click="letter = 'g'">G</td>
              <td :class="letter == 'h' ? 'letterActiva' : ''"
                  @click="letter = 'h'">H</td>
              <td :class="letter == 'i' ? 'letterActiva' : ''"
                  @click="letter = 'i'">I</td>
            </tr>
            <tr>
              <td :class="letter == 'j' ? 'letterActiva' : ''"
                  @click="letter = 'j'">J</td>
              <td :class="letter == 'k' ? 'letterActiva' : ''"
                  @click="letter = 'k'">K</td>
              <td :class="letter == 'l' ? 'letterActiva' : ''"
                  @click="letter = 'l'">L</td>
              <td :class="letter == 'm' ? 'letterActiva' : ''"
                  @click="letter = 'm'">M</td>
              <td :class="letter == 'n' ? 'letterActiva' : ''"
                  @click="letter = 'n'">N</td>
              <td :class="letter == 'o' ? 'letterActiva' : ''"
                  @click="letter = 'o'">O</td>
              <td :class="letter == 'p' ? 'letterActiva' : ''"
                  @click="letter = 'p'">P</td>
              <td :class="letter == 'q' ? 'letterActiva' : ''"
                  @click="letter = 'q'">Q</td>
              <td :class="letter == 'r' ? 'letterActiva' : ''"
                  @click="letter = 'r'">R</td>
              <td :class="letter == 's' ? 'letterActiva' : ''"
                  @click="letter = 's'">S</td>
            </tr>
            <tr>
              <td :class="letter == 't' ? 'letterActiva' : ''"
                  @click="letter = 't'">T</td>
              <td :class="letter == 'u' ? 'letterActiva' : ''"
                  @click="letter = 'u'">U</td>
              <td :class="letter == 'v' ? 'letterActiva' : ''"
                  @click="letter = 'v'">V</td>
              <td :class="letter == 'w' ? 'letterActiva' : ''"
                  @click="letter = 'w'">W</td>
              <td :class="letter == 'x' ? 'letterActiva' : ''"
                  @click="letter = 'x'">X</td>
              <td :class="letter == 'y' ? 'letterActiva' : ''"
                  @click="letter = 'y'">Y</td>
              <td :class="letter == 'z' ? 'letterActiva' : ''"
                  @click="letter = 'z'">Z</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="box">
      <div class="boxleft">
        <div :class="getLeftShow(index) ? 'blbox2' : 'blbox'"
             v-for="(item, index) in leftList"
             :key="index">
          <p>{{ item.name }}</p>
          <div v-if="item.queryCoursesInfoList"
               style="display:flex;flex-direction: column;">
            <span v-for="(items, indexx) in item.queryCoursesInfoList.slice(0, 4)"
                  v-show="!getLeftShow(index)"
                  :style="getbiaoqianList(items.id) ? 'text-decoration: underline;color: #007380;' : ''"
                  @click="tobiaoqian(items.id,item.queryCoursesInfoList)"
                  :key="indexx + 's'">{{ items.name }}</span>
          </div>
          <span v-for="(items, indexx) in item.queryCoursesInfoList"
                v-show="getLeftShow(index)"
                :style="getbiaoqianList(items.id) ? 'text-decoration: underline;color: #007380;' : ''"
                @click="tobiaoqian(items.id,item.queryCoursesInfoList)"
                :key="indexx + 's2'">{{ items.name }}</span>
          <img src="../../assets/img/icon/xia2.png"
               @click="toleftshow(index)"
               v-show="item.queryCoursesInfoList.length>4"
               alt="" />
        </div>
        <div :class="getLeftShow(-1) ? 'blbox2' : 'blbox'">
          <p>授课内容</p>
          <div style="display:flex;flex-direction: column;">
            <span v-for="(items, indexx) in leftList2.slice(0, 4)"
                  v-show="!getLeftShow(-1)"
                  :style="getbiaoqianList2(items.id) ? 'text-decoration: underline;color: #007380;' : ''"
                  @click="tobiaoqian2(items.id)"
                  :key="indexx + 's'">{{ items.name }}</span>
          </div>
          <span v-for="(items, indexx) in leftList2"
                v-show="getLeftShow(-1)"
                :style="getbiaoqianList2(items.id) ? 'text-decoration: underline;color: #007380;' : ''"
                @click="tobiaoqian2(items.id)"
                :key="indexx + 's2'">{{ items.name }}</span>
          <img src="../../assets/img/icon/xia2.png"
               @click="toleftshow(-1)"
               v-show="leftList2.length>4"
               alt="" />
        </div>
      </div>
      <div class="boxright">
        <div class="list"
             v-if="list.length > 0">
          <div class="listTop">
            <div class="listBox"
                 v-for="(item, index) in list"
                 @click="toDetail(item.id)"
                 :key="index">
              <img :src="item.headPicture"
                   alt="" />
              <div class="lbRight">
                <span class="name">{{ item.name }}</span>
                <div class="more">
                  <span>{{ item.techTitle }}</span>
                  <span>{{ item.unit }}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="fenye">
            <pagination :total="pageCount"
                        :limit="pageSize"
                        :page="pageIndex"
                        @page-change="pageChange"></pagination>

            <div class="tablesum">共 <span style="color:#0B8586">{{pageCount}}</span> 条</div>
          </div>
        </div>
        <div class="nolist"
             v-if="list.length == 0">
          <span>没有找到符合条件的专家</span>
        </div>
      </div>
    </div>
    <footer_index></footer_index>
  </div>
</template>

<script>
import header_index from '../../components/header2';
import footer_index from './footer_index.vue';
export default {
  components: {
    header_index,
    footer_index
  },
  name: 'experts',
  data () {
    return {
      topRotation: [
        // {
        //   resUrl: '/image/index/zhuanjia.png'
        // }
      ],
      righttopRotation: [],
      swiperOption: {
        loop: true,
        // 显示分页
        pagination: {
          el: '.swiper-pagination',
          bulletClass: 'bulletWrite',
          bulletActiveClass: 'bulletWriteActive'
        }
      },
      tbIndex: 1,
      topList: [],
      letter: '',
      isLetter: false,
      list: [],
      pageCount: 0,
      pageIndex: 1,
      pageSize: 10,
      name: '',
      leftList: [],
      leftShowList: [],
      biaoqianList: [],
      //   biaoqianList2: [],
      biaoqianStr: '',
      biaoqianStr2: '',
      leftList2: [],
      isloading: false
    };
  },
  watch: {
    letter: function () {
      this.pageIndex = 1
      this.GetList();
    },
    biaoqianList: function () {
      this.biaoqianStr = this.biaoqianList.join(',');
      this.pageIndex = 1
      this.GetList();
    },
    biaoqianStr2: function () {
      //   this.biaoqianStr2 = this.biaoqianList2.join(',');
      this.pageIndex = 1
      this.GetList();
    }
  },
  created () {
    this.GetTopList();
    this.GetList();
    this.GetLeftList();
    this.GetRotationInfo();
  },
  methods: {
    //获取轮播数据
    GetRotationInfo () {
      let _this = this;
      let arr = [5]; //分别代表杂志专区轮播，底部，右上，右下
      for (let i = 0; i < arr.length; i++) {
        _this.httphelper
          .post('/api/WebSetMessApi/GetRotationInfo', {
            type: arr[i],
            ruselocation: 1,
            source: 1
          })
          .then(res => {
            if (res.data.code == 200) {
              if (arr[i] == 5) {
                _this.topRotation = res.data.data || null;
              }
            }
          });
      }
    },
    textFormat (val) {
      return val
        .replace(/<[^>]+>/g, '')
        .replace(/&mdash;/g, '')
        .replace(/&ldquo;/g, '')
        .replace(/&rdquo;/g, '')
        .replace(/&gamma;/g, '')
        .replace(/&beta;/g, '')
        .replace(/#br#/g, '')
        .replace(/&quot;/g, '')
        .replace(/&kappa;/g, '');
    },
    GetTopList () {
      this.httphelper
        .post('/api/CGPExpertApi/GetExpertPageList', {
          name: '',
          searchOne: '',
          searchTwo: '',
          source: '',
          letter: '',
          page: this.tbIndex,
          limit: 5
        })
        .then(res => {
          if (res.data.code == 200) {
            this.topList = res.data.data;
          }
        });
    },
    tonext (num) {
      this.tbIndex = num;
      this.isloading = true
      this.GetTopList();
      var that = this
      setTimeout(() => {
        that.isloading = false
      }, 100);
    },
    toSearch () {
      this.pageIndex = 1
      this.GetList();

    },
    GetList () {
      this.httphelper
        .post('/api/CGPExpertApi/GetExpertPageList', {
          name: this.name,
          searchOne: this.biaoqianStr,
          searchTwo: this.biaoqianStr2,
          letter: this.letter,
          page: this.pageIndex,
          limit: this.pageSize
        })
        .then(res => {
          if (res.data.code == 200) {
            this.list = res.data.data;
            this.pageCount = res.data.totalcount;
          }
        });
    },
    pageChange (page) {
      if (page == this.pageIndex) return;
      this.pageIndex = page;
      this.GetList();
    },
    // GetLeftList () {
    //   this.httphelper
    //     .get('/api/CGPExpertApi/GetExpertLabelList').then(res => {
    //       if (res.code == 200) {
    //         this.leftList = res.data
    //       }
    //     });
    // },
    GetLeftList () {
      this.httphelper.get('/api/CGPExpertApi/GetExpertLabelList').then(res => {
        if (res.code == 200) {
          this.leftList = res.data.elablist;
          this.leftList2 = res.data.clablist;
        }
      });
    },
    getLeftShow (index) {
      for (let i = 0; i < this.leftShowList.length; i++) {
        if (this.leftShowList[i] == index) return true;
      }
    },
    getbiaoqianList (id) {
      for (let i = 0; i < this.biaoqianList.length; i++) {
        if (this.biaoqianList[i] == id) return true;
      }
    },
    tobiaoqian (id, item) {
      let j = true;
      //   let b = true
      //   for (let a = 0; a < item.length; a++) {
      //     if (item[a].id == id) {
      //       b = false
      //     }
      //   }
      for (let i = 0; i < this.biaoqianList.length; i++) {
        for (let a = 0; a < item.length; a++) {
          if (item[a].id == this.biaoqianList[i]) {
            if (item[a].id == id) {
              this.biaoqianList.splice(i, 1);
            } else {
              this.biaoqianList.splice(i, 1);
              this.biaoqianList.push(id);
            }
            j = false
            return
          }
        }
      }
      //   if (item[a].id == id) {
      //     b = false
      //     if (this.biaoqianList[i] == id) {
      //       this.biaoqianList.splice(i, 1);
      //       a = false
      //       return
      //     }
      //   }
      if (j == true) {
        this.biaoqianList.push(id);
      }
    },
    getbiaoqianList2 (id) {
      //   for (let i = 0; i < this.biaoqianList2.length; i++) {
      //     if (this.biaoqianList2[i] == id) return true;
      //   }
      if (this.biaoqianStr2 == id) return true;
    },
    tobiaoqian2 (id) {
      //   let a = true;
      //   for (let i = 0; i < this.biaoqianList2.length; i++) {
      //     if (this.biaoqianList2[i] == id) {
      //       this.biaoqianList2.splice(i, 1);
      //       a = false;
      //     }
      //   }
      //   if (a == true) this.biaoqianList2.push(id);
      if (this.biaoqianStr2 == id) this.biaoqianStr2 = ''
      else this.biaoqianStr2 = id.toString()
    },
    toEnter () {
      if (this.$cookies.isKey('token_chinagp')) {
        this.$router.push({
          path: '/user/userExpertsEnter'
        });
      } else {
        this.$router.push({
          name: 'login',
          query: {
            callback: encodeURIComponent(window.location.href)
          }
        })
      }

    },
    toDetail (id) {
      this.$router.push({
        path: '/expertsDetail',
        query: {
          id: id
        }
      });
    },
    toleftshow (id) {
      let type = true
      for (let i = 0; i < this.leftShowList.length; i++) {
        if (this.leftShowList[i] == id) {
          this.leftShowList.splice(i, 1);
          type = false
        }
      }
      if (type == true) this.leftShowList.push(id)
    },
    getNameSize (str, type) {
      let word = /[a-zA-Z]/
      let num = str.length
      if (word.test(str)) {
        if (type == 1) {
          if (num < 12) return 20
          else if (12 < num && num < 16) return 19
          else if (16 < num && num < 20) return 18
          else return 17
        } else if (type == 2) {
          if (num < 12) return 20
          else if (12 < num && num < 16) return 18
          else if (16 < num && num < 20) return 17
          else return 15
        } else if (type == 3) {
          if (num < 12) return 20
          else if (12 < num && num < 16) return 17
          else if (16 < num && num < 20) return 15
          else return 13
        }
      }
    }
  }
};
</script>

<style scoped>
.content {
    flex: 1;
}

.bannerWrap {
    height: 450px;
    padding-top: 40px;
    box-sizing: border-box;
    background: linear-gradient(180deg, #dbeded, #ffffff);
}

.topbanner {
    height: 380px;
}

.bannerleft {
    width: 930px;
    height: 380px;
    background: #006773;
    box-shadow: 0px 16px 14px 0px rgba(0, 0, 0, 0.15);
    border-radius: 20px 0px 0px 0px;
}

.bannerright {
    width: 299px;
    height: 380px;
    background: #006773;
    box-shadow: 0px 16px 14px 0px rgba(0, 0, 0, 0.06);
    border-radius: 0px 0px 20px 0px;
    padding: 50px 0px 55px 40px;
    box-sizing: border-box;
    position: relative;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
}
.bannerright .brTop {
    display: flex;
    flex-direction: column;
    font-family: Microsoft YaHei;
    color: #ffffff;
}
.bannerright .brBottom {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    width: 160px;
    height: 32px;
    background: #ffffff;
    border-radius: 16px;
    cursor: pointer;
    z-index: 200;
}

.shan {
    position: absolute;
    right: 0;
    bottom: 0;
}

.bannerTitle {
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #ffffff;
    line-height: 38px;
}
.topneirong {
    /* word-break: break-all;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 6;
    -webkit-box-orient: vertical; */
    z-index: 1000;
    overflow-y: scroll;
    height: 120px;
    padding-right: 30px;
    margin-right: 10px;
    scrollbar-color: transparent transparent;
    scrollbar-arrow-color: #f0f2f5; /* 设置滚动条上的箭头颜色  */
    scrollbar-base-color: #f0f2f5; /* 设置滚动条的底色 */
    scrollbar-track-color: #f0f2f5; /* 设置滚动条块的背景色 */
    scrollbar-shadow-color: #f0f2f5; /* 设置箭头和滚动条右侧和底边的颜色 */
}
.topneirong::-webkit-scrollbar {
    /* 滚动条宽 */
    width: 4px;
    height: 4px;
}
.topneirong::-webkit-scrollbar-thumb {
    /* 滚动条 拖动条 */
    background-color: #3d98ff;
    border-radius: 4px;
}
.topneirong::-webkit-scrollbar-track {
    /* 滚动条背景槽 */
    background-color: #eee;
    border-radius: 4px;
}
.bannerText {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #ffffff;
    line-height: 25px;
}

.bannerline {
    width: 40px;
    height: 1px;
    background: #ffffff;
    margin-top: 20px;
    margin-bottom: 18px;
}

.bannerBtn {
    display: inline-block;
    width: 121px;
    height: 32px;
    background: #ffffff;
    border-radius: 16px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #000000;
    line-height: 32px;
    text-align: center;
}
.swiper-pagination {
    text-align: left;
    box-sizing: border-box;
    padding-left: 20px;
}
.top1 {
    height: 32px;
    border-left: 3px solid #107c81;
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
    line-height: 32px;
    width: 1240px;
    margin: 16px auto 0;
    padding-left: 13px;
    box-sizing: border-box;
}

.top2 {
    width: 1240px;
    height: 70px;
    margin: 34px auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eee;
    position: relative;
}
.top2 .top1 {
    width: 540px;
    margin-left: 0;
}
.t2right {
    display: flex;
    position: relative;
}
.t2rInput {
    width: 297px;
    height: 36px;
    background: #ffffff;
    border: 1px solid #007380;
    padding: 8px 15px 8px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.t2rBtn {
    width: 38px;
    height: 38px;
}
.t2rBtn img {
    width: 38px;
    height: 36px;
}
.t2rInput span {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
}
.t2rInput input {
    border: none;
    outline: none;
}
.t2rInput .letter {
    display: flex;
    align-items: center;
    cursor: pointer;
}
.t2rInput .letter img {
    margin: 0 5px 0 15px;
}
.t2rInput .letter span {
    width: 30px;
    text-align: center;
}
.t2rzm {
    width: 335px;
    height: 124px;
    background: #ffffff;
    border: 1px solid #007380;
    position: absolute;
    bottom: -121px;
    left: 0px;
    padding: 7px;
    box-sizing: border-box;
}
.top2xian {
    width: 145px;
    height: 1px;
    background: #000000;
    position: absolute;
    bottom: 0;
    left: 0;
}
.box {
    width: 1240px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
}
.boxleft {
    display: flex;
    flex-direction: column;
}
.blbox,
.blbox2 {
    width: 229px;
    background: #f6f7fb;
    margin-bottom: 20px;
    border-top: 1px solid #007380;
    padding-left: 20px;
    position: relative;
    display: flex;
    flex-direction: column;
    padding-bottom: 10px;
}
.blbox p,
.blbox2 p {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
    line-height: 40px;
    margin-top: 10px;
}
.blbox span,
.blbox2 span {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    line-height: 30px;
    cursor: pointer;
}
.blbox2 img {
    width: 11px;
    height: 13px;
    transform: rotate(180deg);
    position: absolute;
    right: 20px;
    bottom: 20px;
    cursor: pointer;
    padding: 5px;
}
.blbox img {
    width: 11px;
    height: 13px;
    position: absolute;
    right: 20px;
    bottom: 20px;
    cursor: pointer;
    padding: 5px;
}
.topBox {
    height: 310px;
    width: 1240px;
    box-sizing: border-box;
    margin: 0 auto;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    padding: 0 30px;
    position: relative;
}
.topBox .name {
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #1e1e1e;
    line-height: 26px;
}
.topBox .more {
    display: flex;
    align-items: center;
}
.topBox .more img {
    margin-right: 10px;
}
.tb3 {
    width: 170px;
    height: 230px;
}
.tb3 .touxiang {
    width: 150px;
    height: 150px;
    margin: 10px;
    border-radius: 50%;
}
.tb3 .img2 {
    margin: 69px;
}
.tb2 {
    width: 210px;
    height: 270px;
}
.tb2 .touxiang {
    width: 190px;
    height: 190px;
    margin: 10px;
    border-radius: 50%;
}
.tb2 .img2 {
    margin: 89px;
}
.tb1 {
    width: 250px;
    height: 310px;
    position: relative;
}
.tb1 .touxiang {
    width: 230px;
    height: 230px;
    margin: 10px;
    border-radius: 50%;
}
.tb1 .img2 {
    margin: 109px;
}
.tb1 .huangguan {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 50px;
    height: 50px;
    margin: 0;
}
.tb3top {
    width: 170px;
    height: 170px;
    background: #ffffff;
    box-shadow: 10px 17px 20px 0px rgba(0, 0, 0, 0.07);
    border-radius: 50%;
}
.tb2top {
    width: 210px;
    height: 210px;
    background: #ffffff;
    box-shadow: 10px 17px 20px 0px rgba(0, 0, 0, 0.07);
    border-radius: 50%;
}
.tb1top {
    width: 250px;
    height: 250px;
    background: #ffffff;
    border: 1px solid #006773;
    box-shadow: 10px 17px 20px 0px rgba(0, 103, 115, 0.1);
    border-radius: 50%;
    box-sizing: border-box;
}
.tbbtn {
    position: absolute;
    bottom: 125px;
}
.tbleft {
    left: -37px;
}
.tbright {
    right: -37px;
}
.tbbtn img {
    width: 37px;
    height: 37px;
}
.tbbox {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
}
.t2rzm td {
    width: 33px;
    font-size: 12px;
    font-family: Arial;
    font-weight: 400;
    color: #7e7e7e;
    line-height: 32px;
    text-align: center;
    cursor: pointer;
}
.t2rzm .letterActiva {
    text-decoration: underline;
    color: #007380;
}
.boxright {
    flex: 1;
}
.boxright .nolist {
    text-align: center;
    line-height: 100px;
}
.boxright .list {
    padding-left: 50px;
}
.boxright .listTop {
    display: flex;
    flex-wrap: wrap;
}
.boxright .listBox {
    display: flex;
    margin-left: 30px;
    width: 440px;
    height: 140px;
    margin-bottom: 40px;
    cursor: pointer;
}
.boxright .listBox img {
    width: 140px;
    height: 140px;
    margin-right: 30px;
}
.boxright .listBox .lbRight {
    display: flex;
    flex: 1;
    justify-content: space-between;
    flex-direction: column;
    padding: 10px 0;
}
.boxright .listBox .name {
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #1e1e1e;
}
.boxright .listBox .more {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #1e1e1e;
    line-height: 28px;
    display: flex;
    flex-direction: column;
}
.tablesum {
    width: 80px;
    position: absolute;
    bottom: 0;
    right: 59px;
    text-align: right;
}
.fenye {
    width: 100%;
    /* position: absolute; */
    position: relative;
    /* left: 0px;
    bottom: 35px; */
}
</style>
